
class MicroneedlingAnchors extends HTMLElement {
    constructor() {
        super();

        this.offsetTopE = this.offsetHeight;

        let siteHeader = document.getElementById('SiteHeader');
        if(siteHeader.dataset.sticky){
            let headerSticky = siteHeader.querySelector('.site-header__element--top');
           this.offsetTopE += headerSticky.offsetHeight;
        }

        this.buttonContainer = this.querySelector('.anchors-link');
        this.buttons = this.querySelectorAll('.anchor-link');
        this.headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
        this.generateLinks();

        if(this.classList.contains('sticky')) {
            this.setSticky();
        }
        
        Array.from(this.buttons).forEach(function(button){
            button.addEventListener('click', this.scrollToAnchor.bind(this));
        }, this);

        window.addEventListener('scroll', this.highlightButtonWhenScroll.bind(this));
    }
    setSticky() {
        let top = 0;

        let siteHeader = document.getElementById('SiteHeader');
        if(siteHeader.dataset.sticky){
            let headerSticky = siteHeader.querySelector('.site-header__element--top');
            top = headerSticky.offsetHeight - 1;
        }

        let parentE = this.parentElement;
        parentE.style.position = 'sticky';
        parentE.style.top = top + 'px';
        parentE.style.zIndex = 5;
        parentE.style.background = '#fff';
    }
    generateLinks() {
        
        
        Array.from(this.buttons).forEach(function(button){
            let text_target = button.dataset.target;
            let link_target = button.getAttribute('href');
            
            Array.from(this.headings).forEach(function(heading){
                
                if(heading.innerText == text_target) {
                    let section = heading.closest('.shopify-section');

                    let linkElement = document.createElement('div');
                    linkElement.classList.add('microneedling-anchor-link');
                    linkElement.id = link_target.replaceAll('#', '');

                    section.insertBefore(linkElement, section.children[0]);

                    // heading.id = link_target.replaceAll('#', '');
                    // heading.classList.add('microneedling-anchor-heading');
                }
            }, this);
        }, this);
        this.anchors = document.querySelectorAll('.microneedling-anchor-link');
    }
    scrollToAnchor(e) {
        
        Array.from(this.buttons).forEach(function(button){
            button.classList.remove('active');
        });
        e.target.classList.add('active');
        let hashval = e.target.getAttribute('href');
        let target = document.querySelector(hashval);

        let y = target.offsetTop - this.offsetTopE - parseFloat(e.target.dataset.click);
        
        window.scrollTo({top: y, behavior: 'smooth'});
        e.preventDefault();
    }
    highlightButtonWhenScroll(e) {
        let fromTop = window.scrollY + this.offsetTopE;
        let currentPaddingContainer = window.getComputedStyle(this.buttonContainer, null).getPropertyValue('padding-left');
        currentPaddingContainer = currentPaddingContainer.replace('px', '');
        Array.from(this.buttons).forEach(function(button, index){
            let heading = document.querySelector(button.hash);
            let start = heading.offsetTop - parseFloat(button.dataset.scroll);
            let end = 0;
            if(index < this.buttons.length - 1) {
                let nextHeading = this.anchors[index + 1];
                let nextButton = this.buttons[index + 1];
                end = nextHeading.offsetTop - parseFloat(nextButton.dataset.scroll);
            }else {
                end = document.getElementsByTagName('body')[0].offsetHeight;
            }

            if (start <= fromTop && end > fromTop) {
                button.classList.add("active");
                // scroll to highlight button 
                this.buttonContainer.scrollLeft = button.offsetLeft - parseFloat(currentPaddingContainer);
            } else {
                button.classList.remove("active");
            }
        }, this);
    }
    
}
  
customElements.define('microneedling-anchors', MicroneedlingAnchors);